// extracted by mini-css-extract-plugin
export var blue = "_1q-f";
export var brand = "_1q-b";
export var darkGrey = "_1q-e";
export var disabled = "_1q-4";
export var disabledSubtle = "_1q-5";
export var error = "_1q-6";
export var green = "_1q-g";
export var grey = "_1q-d";
export var icon = "_1q-0";
export var inherit = "_1q-a";
export var lightGrey = "_1q-c";
export var orange = "_1q-i";
export var pink = "_1q-k";
export var primary = "_1q-1";
export var purple = "_1q-l";
export var red = "_1q-j";
export var secondary = "_1q-2";
export var success = "_1q-9";
export var tertiary = "_1q-3";
export var warning = "_1q-7";
export var warningSecondary = "_1q-8";
export var white = "_1q-m";
export var yellow = "_1q-h";